import React from 'react';
import PropTypes from 'prop-types';
import Tag from './tag';
import './tags.scss';

const Tags = ({ gaCategory, onClickTag, scroll, tags, titleOnSameLine }) =>
    tags &&
    tags.length > 0 && (
        <div
            className={`tags-wrapper py-2 ${scroll ? 'tags-scroll' : ''} ${
                titleOnSameLine ? 'tags-inline' : ''
            }`}>
            {tags.map(tag => (
                <Tag
                    gaCategory={gaCategory}
                    key={tag.name}
                    name={tag.name}
                    onClick={() =>
                        typeof onClickTag === 'function' && onClickTag(tag)
                    }
                    url={tag.url}
                />
            ))}
        </div>
    );

Tags.defaultProps = {
    scroll: false,
    titleOnSameLine: false
};

Tags.propTypes = {
    gaCategory: PropTypes.string,
    onClickTag: PropTypes.func,
    scroll: PropTypes.bool,
    tags: PropTypes.array.isRequired,
    titleOnSameLine: PropTypes.bool
};

export default Tags;
